// ===== Menú móvil =====
function toggleMenu() {
  var m = document.getElementById('nav-links');
    if (m) m.classList.toggle('open');
  }

function closeMenu() {
  var m = document.getElementById('nav-links');
  if (m) m.classList.remove('open');
}

// ===== FAQ de la portada =====
function toggleFaq(el) {
  el.parentElement.classList.toggle('open');
}

// ===== Pestañas de la ficha de producto =====
function selTab(btn, id) {
  btn.closest('.pdp-tabs').querySelectorAll('.pdp-tab-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  btn.closest('.pdp-tabs').querySelectorAll('.pdp-tab-pane').forEach(p => p.classList.remove('active'));
  document.getElementById(id).classList.add('active');
}

// ===== ANIMACIÓN AL HACER SCROLL =====
(function () {
  function tag(el, dir) {
    if (el.dataset.reveal) return;
    el.classList.add('reveal');
    if (dir === 'left') el.classList.add('reveal-left');
    if (dir === 'right') el.classList.add('reveal-right'); el.dataset.reveal = '1';
  }

  // grupos con efecto escalonado
  function tagStagger(selector) {
    const byParent = new Map();
    document.querySelectorAll(selector).forEach(el => {
      tag(el);
      const p = el.parentElement;
      const a = byParent.get(p) || [];
      a.push(el); byParent.set(p, a);
    });
    byParent.forEach(arr => arr.forEach((el, i) => {
      el.style.transitionDelay = Math.min(i * 0.08, 0.48) + 's';
    }));
  }

  // hero
  document.querySelectorAll('.hero-copy > *').forEach((el, i) => {
    tag(el);
    el.style.transitionDelay = (i * 0.1) + 's';
  });
  document.querySelectorAll('.hero-photo').forEach(el => tag(el, 'right'));

  // encabezados de sección, en cascada eyebrow > título > sub
  document.querySelectorAll('.section-inner').forEach(si => {
    let i = 0;
    si.querySelectorAll(':scope > .section-eyebrow, :scope > .section-title, :scope > .section-sub').forEach(el => {
      tag(el); el.style.transitionDelay = (i++ * 0.09) + 's';
    });
  });
  ['.section-eyebrow', '.section-title', '.section-sub', '.related-title', '.related-sub', '.consume-eyebrow', '.consume-title'].forEach(s => document.querySelectorAll(s).forEach(el => tag(el)));

  // producto estrella: mitades entran desde los lados
  document.querySelectorAll('.star-img').forEach(el => tag(el, 'left'));
  document.querySelectorAll('.star-body').forEach(el => tag(el, 'right'));

  // tarjetas y bloques repetidos, escalonados
  ['.prod-card', '.pack-card', '.feature', '.faq-item', '.consume-step', '.timeline-item', '.step', '.contact-info-item', '.checkout-block', '.related-card'].forEach(tagStagger);

  const supported = 'IntersectionObserver' in window;
  const io = supported ? new IntersectionObserver(function (entries)
  {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, {
    threshold: 0.12, rootMargin: '0px 0px -8% 0px'
  }) : null;

  window.__revealInView = function () {
    document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
      const r = el.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight * 0.95) {
        el.classList.add('is-visible');
        if (io) io.unobserve(el);
      }
    });
  };

  if (io) {
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  }
  else {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('is-visible'));
  }

  // revelar lo que ya está en pantalla al cargar
  requestAnimationFrame(window.__revealInView);
})();

// Render lucide icons
if (window.lucide) {
  lucide.createIcons();
}

// ===== Ficha de producto: formato, cantidad, precio y galería =====
let productQty = 1;
let currentVariantPrice = 0;

document.addEventListener("DOMContentLoaded", function () {

    const priceBox = document.getElementById("pdp-price");

    if (priceBox) {
        currentVariantPrice = parseInt(priceBox.dataset.price || 0);
    }

    updateProductPrice();
});


function formatMoney(cents) {

    return new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
        minimumFractionDigits: 0
    }).format(cents / 100);

}

function changeMedia(el) {

    document.querySelectorAll('.pdp-thumb').forEach(t=>{
        t.classList.remove('active');
    });

    el.classList.add('active');

    let type = el.dataset.type;

    let wrapper = document.getElementById('pdp-main-media');

    if(type === 'image'){

        wrapper.innerHTML = `
            <img
                id="pdp-main-img"
                src="${el.dataset.src}"
                alt=""
            >
        `;

    }else if(type === 'video'){

        wrapper.innerHTML = `
            <video
                controls
                autoplay
                playsinline
                width="100%">
                <source src="${el.dataset.video}" type="video/mp4">
            </video>
        `;

    }

}


/**************** PDP Qty JS *******************/

window.changeQty = function (change) {

    productQty += change;

    if (productQty < 1) {
        productQty = 1;
    }

    document.getElementById("qty-value").textContent = productQty;
    document.getElementById("qty-input").value = productQty;

    updateProductPrice();

}

window.selectVariant = function (el) {

    document.querySelectorAll(".fmt-opt").forEach(function (btn) {
        btn.classList.remove("sel");
    });

    el.classList.add("sel");

    currentVariantPrice = parseInt(el.dataset.price);

    document.getElementById("variant-id").value = el.dataset.id;

    updateProductPrice();

}
function updateProductPrice() {

    const priceEl = document.getElementById("pdp-price");

    if (!priceEl) return;

    priceEl.innerHTML = formatMoney(currentVariantPrice * productQty);

}

// ===== Ficha: la píldora marcada es la variante que se va a comprar =====
// La sección marcaba siempre la primera píldora aunque estuviera agotada, mientras
// el precio y el carrito tomaban la primera variante disponible.
(function () {
  const input = document.getElementById('variant-id');
  const pills = document.querySelectorAll('.fmt-opt');
  if (!input || !pills.length) return;
  pills.forEach(function (b) { b.classList.toggle('sel', b.dataset.id === input.value); });

  // Formatos agotados: se ven tachados y no se pueden elegir
  fetch(location.pathname.replace(/\/$/, '') + '.js')
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p || !p.variants) return;
      p.variants.forEach(function (v) {
        if (v.available) return;
        const b = document.querySelector('.fmt-opt[data-id="' + v.id + '"]');
        if (!b) return;
        b.disabled = true;
        b.classList.add('agotado');
        b.title = 'Agotado';
      });
    })
    .catch(function () {});
})();